import { checkEmptyObject } from "../../../../../../../services";
import { emptyUUID, HrCountryId } from "../../../../../../../models/enums";

const EMPTY_ID = emptyUUID;

// A level below the top one that offers nothing (a make without models) is not
// required: the chain is complete once every level that has options has a value.
const levelHasNothingToOffer = level =>
  Array.isArray(level.options) && level.options.length === 0;

// true = some level is missing ("Odaberite sve razine")
const validateAllLevels = (object, value, isTopLevel = true) => {
  if (!object.child) {
    return false;
  }

  const level = object.child;

  if (checkEmptyObject(level.value)) {
    return validateAllLevels(level, value, false);
  }

  if (!isTopLevel && levelHasNothingToOffer(level)) {
    return false;
  }

  if (
    value[level.field] &&
    (level.field == "settlementId" || level.field == "modelId")
  ) {
    return false;
  }

  return true;
};

export default {
  // TODO: need to use onError for now because we dont have enough time to fix mutate of props
  // in multi level level
  // eslint-disable-next-line complexity


  validate(control, rule, value, callback, errors = null) {
    if (!value) {
      callback("Odaberite sve razine");
      return;
    }

    if (control.dataSource === "location") {
      const allValuesExist = [value.countryId, value.countyId, value.cityId, value.settlementId].every(v => v && v !== EMPTY_ID)
      const selectedCountryIsNotCroatia = value.countryId && value.countryId !== HrCountryId
      callback(allValuesExist || selectedCountryIsNotCroatia ? undefined : "Odaberite sve razine")
      return;
    }

    const topField = control.child && control.child.field;
    if (topField && !value[topField]) {
      callback("Odaberite sve razine");
      return;
    }

    // The selector reports on every change, from the current make/subcategory data, whether a
    // deeper level is still required (onError). That verdict is already up to date when this
    // validator runs on change, whereas the options/value injected into the control chain are
    // from the previous render and the form caches the on-change result until the next change.
    // A make without models would otherwise keep a stale "Odaberite sve razine" until submit.
    if (errors && Object.prototype.hasOwnProperty.call(errors, control.id)) {
      callback(errors[control.id] || undefined);
      return;
    }

    // No interaction yet (edit page, restored draft): the chain was rendered before submit, so
    // the injected options/values are current and can be walked.
    if (validateAllLevels(control, value)) {
      callback("Odaberite sve razine");
      return;
    }


    // TODO: refactor, remove onError and state mutation and uncomment these line
    // let level = control.child;
    // while (level && level.options && level.options.length > 0) {
    //   if (!value[level.field]) {
    //     callback("Odaberite sve razine");
    //     return;
    //   }
    //   level = level.child;
    // }

    callback();
  }
};



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/ValidationRuleResolver/MultiLevelValidator.ts